import { Icon } from '../components/Icon';
import { GlobalSearch } from '../components/GlobalSearch';

interface Props {
  title: string;
  sub: string;
  onMenu: () => void;
  onBack?: () => void;
  onNewClient: () => void;
  onOpenClient: (id: string) => void;
}

export function Topbar({ title, sub, onMenu, onBack, onNewClient, onOpenClient }: Props) {
  return (
    <header className="topbar">
      <button type="button" className="icon-btn hamburger" onClick={onMenu} aria-label="Menu">
        <Icon name="menu" size={20} />
      </button>
      {onBack && (
        <button type="button" className="icon-btn rs-back" onClick={onBack} aria-label="Indietro">
          <Icon name="cleft" size={20} />
        </button>
      )}
      <div className="topbar-title">
        <h1>{title}</h1>
        {sub && <span className="topbar-sub">{sub}</span>}
      </div>
      <div className="topbar-spacer" />
      <div className="topbar-actions">
        <GlobalSearch onOpen={onOpenClient} />
        <button type="button" className="btn btn-primary" onClick={onNewClient}>
          <Icon name="plus" size={16} />
          <span className="btn-label">Nuovo cliente</span>
        </button>
      </div>
    </header>
  );
}
